module.exports = __webpack_public_path__ + "6830bb6aee8420c421e8f1a7704cd37f.png";